import React, { Component, Dispatch } from 'react';
import { Log, Level, Logger, Display } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { IUserHome } from '../../models/pages/userHome';
import { connect } from 'react-redux';
import { UserType } from '../../models/pages/login.d';
import { StudentHome } from './student/main';
import { TeacherHome } from './teacher/main';
import { AdminHome } from './admin/main';
import { withRouter } from 'react-router-dom';

const _logger = Log.create('pages-user-main');
class UserHome extends React.Component<IUserHome> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        if(!this.props.IsActiveSSE)
        {
            return <></>;
        }
        return (
            (this.props.userType && this.props.userType === UserType.Student) ? (
                <StudentHome />
            ) : (this.props.userType && this.props.userType === UserType.Admin) ? (
                <AdminHome />
            ) : (
                <TeacherHome />
            )
        );
    }
}
const mapStateToProps = (state: IAppState, ownProps: IUserHome): IUserHome => {
    if (!state) {
        return ownProps;
    }
    const newProps: IUserHome = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType
    });
    return newProps;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const CUserHome = connect(
    mapStateToProps,
    dispatchProps
)(UserHome);

export default withRouter<any, any>(CUserHome);
